import { render, staticRenderFns } from "./account_settings_header.vue?vue&type=template&id=0665f43c&scoped=true&"
import script from "./account_settings_header.vue?vue&type=script&lang=js&"
export * from "./account_settings_header.vue?vue&type=script&lang=js&"
import style0 from "./account_settings_header.vue?vue&type=style&index=0&id=0665f43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665f43c",
  null
  
)

export default component.exports